"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIRE_EXCEPTION_RFI_SUBTYPE = exports.ACH_CLAIMS_RFI_SUBTYPE = exports.COMPLAINTS_RFI_SUBTYPE = exports.DYNAMIC_QUESTIONS_RFI_SUBTYPE = exports.OFAC_RFI_SUBTYPE = exports.LEGAL_NAME_RFI_SUBTYPE = exports.W9_UPDATE_RFI_SUBTYPE = exports.CLOSE_BUTTON_ALT_TEXT = exports.RFI_DESCRIPTION_02 = exports.RFI_DESCRIPTION_01 = exports.GO_TO_PROFILE = exports.CANCEL_BUTTON = exports.TITLE = exports.BASE_KEY = void 0;
exports.BASE_KEY = 'mbModalUploadDocumentation';
exports.TITLE = `${exports.BASE_KEY}.title`;
exports.CANCEL_BUTTON = `${exports.BASE_KEY}.updateLaterLink`;
exports.GO_TO_PROFILE = `${exports.BASE_KEY}.uploadNowButton`;
exports.RFI_DESCRIPTION_01 = `${exports.BASE_KEY}.description01`;
exports.RFI_DESCRIPTION_02 = `${exports.BASE_KEY}.description02`;
exports.CLOSE_BUTTON_ALT_TEXT = `${exports.BASE_KEY}.a11y.mbModalClose.crossIcon`;
exports.W9_UPDATE_RFI_SUBTYPE = `${exports.BASE_KEY}.w9UpdateSubTypeKey`;
exports.LEGAL_NAME_RFI_SUBTYPE = `${exports.BASE_KEY}.legalNameSubTypeKey`;
exports.OFAC_RFI_SUBTYPE = `${exports.BASE_KEY}.ofacSubTypeKey`;
exports.DYNAMIC_QUESTIONS_RFI_SUBTYPE = `${exports.BASE_KEY}.dynamicQuestionsSubTypeKey`;
exports.COMPLAINTS_RFI_SUBTYPE = `${exports.BASE_KEY}.complaintsSubTypeKey`;
exports.ACH_CLAIMS_RFI_SUBTYPE = `${exports.BASE_KEY}.achClaimsSubtypeKey`;
exports.WIRE_EXCEPTION_RFI_SUBTYPE = `${exports.BASE_KEY}.wireExceptionSubtypeKey`;
//# sourceMappingURL=rfi.literals.js.map